var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('order-report',{on:{"changeShop":_vm.changeShop}}),_c('bulk-shipping-list',{attrs:{"shippingList":_vm.shippingList}}),_c('paging',{attrs:{"meta":_vm.meta},on:{"currentPage":_vm.currentPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }